/*let idTmr;
const getExplorer = () => {
  let explorer = window.navigator.userAgent;
  //ie
  if (explorer.indexOf("MSIE") >= 0) {
    return 'ie';
  }
  //firefox
 
  else if (explorer.indexOf("Firefox") >= 0) {
    return 'Firefox';
  }
  //Chrome
  else if (explorer.indexOf("Chrome") >= 0) {
    return 'Chrome';
  }
  //Opera
  else if (explorer.indexOf("Opera") >= 0) {
    return 'Opera';
  }
  //Safari
  else if (explorer.indexOf("Safari") >= 0) {
    return 'Safari';
  }
}
// 判断浏览器是否为IE
const exportToExcel = (data,name) => {
 
  // 判断是否为IE
  if (getExplorer() == 'ie') {
    tableToIE(data, name)
  } else {
    tableToNotIE(data,name)
  }
}
 
const Cleanup = () => {
  window.clearInterval(idTmr);
}
 
// ie浏览器下执行
const tableToIE = (data, name) => {
  let curTbl = data;
  let oXL = new ActiveXObject("Excel.Application");
 
  //创建AX对象excel
  let oWB = oXL.Workbooks.Add();
  //获取workbook对象
  let xlsheet = oWB.Worksheets(1);
  //激活当前sheet
  let sel = document.body.createTextRange();
  sel.moveToElementText(curTbl);
  //把表格中的内容移到TextRange中
  sel.select;
  //全选TextRange中内容
  sel.execCommand("Copy");
  //复制TextRange中内容
  xlsheet.Paste();
  //粘贴到活动的EXCEL中
 
  oXL.Visible = true;
  //设置excel可见属性
 
  try {
    let fname = oXL.Application.GetSaveAsFilename("Excel.xls", "Excel Spreadsheets (*.xls), *.xls");
  } catch (e) {
    print("Nested catch caught " + e);
  } finally {
    oWB.SaveAs(fname);
 
    oWB.Close(savechanges = false);
    //xls.visible = false;
    oXL.Quit();
    oXL = null;
    // 结束excel进程，退出完成
    window.setInterval("Cleanup();", 1);
    idTmr = window.setInterval("Cleanup();", 1);
  }
}
 
// 非ie浏览器下执行
const tableToNotIE = (function() {
  // 编码要用utf-8不然默认gbk会出现中文乱码
  let uri = 'data:application/vnd.ms-excel;base64,',
    template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
    base64 = function(s) {
      return window.btoa(unescape(encodeURIComponent(s)));
 
    },
 
    format = (s, c) => {
      return s.replace(/{(\w+)}/g,
        (m, p) => {
          return c[p];
        })
    }
  return (table, name) => {
    let ctx = {
      worksheet: name,
      table
    }
 
    //创建下载
    let link = document.createElement('a');
    link.setAttribute('href', uri + base64(format(template, ctx)));
 
    link.setAttribute('download', name);
 
 
    // window.location.href = uri + base64(format(template, ctx))
    link.click();
  }
})()
    
    
    export function   ExcelTest (theadData, tbodyData, dataname){
    	 
       // let re = /.jpg/ // 字符串中包含http,则默认为图片地址
       // let re =  /(\.jpg|\.jpeg|\.JPG|\.JPEG|\.PNG|\.png)$/g;
       let re=/.jpg|.jpeg|.JPG|.JPEG|.PNG/
        let th_len = theadData.length // 表头的长度
        let tb_len = tbodyData.length // 记录条数
        let width = 40 // 设置图片大小
        let height = 40
       
        // 添加表头信息
        let thead = '<thead><tr>'
        for (let i = 0; i < th_len; i++) {
          thead += '<th>' + theadData[i] + '</th>'
        }
        thead += '</tr></thead>'
       
        // 添加每一行数据
        let tbody = '<tbody>'
        for (let i = 0; i < tb_len; i++) {
          tbody += '<tr>'
          let row = tbodyData[i] // 获取每一行数据
       
          for (let key in row) {
            
            if (re.test(row[key])) { // 如果为图片，则需要加div包住图片
                debugger
                var kv=row[key]
                console.log(kv)
                if(Array.isArray(kv)&&kv.length>0){
                    var imglist="";
                    kv.forEach(item=>{
                        imglist='<img src=\'' + item + '\' ' + ' ' + 'width=' + '\"' + width + '\"' + ' ' + 'height=' + '\"' + height + '\"' + '> ';
                        tbody += '<td style="width:50px; height:50px;text-align: center; vertical-align: middle"><div style="display:inline;">'+imglist+'</div></td>'
                    })
                   // console.log(imglist)
                  //  tbody += '<td style="width:50px; height:50px;text-align: center; vertical-align: middle"><div style="display:inline;">'+imglist+'</div></td>'
     
                }else{
                    tbody += '<td style="text-align:center">' + row[key] + '</td>'
                }
             
            } else {
              tbody += '<td style="text-align:center">' + row[key] + '</td>'
            }
          }
          tbody += '</tr>'
        }
        tbody += '</tbody>'
       
        let table = thead + tbody
        console.log(table)
       
        // 导出表格
     exportToExcel(table, dataname)
       
  }

 */

  /* eslint-disable */
let idTmr;
const getExplorer = () => {
  let explorer = window.navigator.userAgent;
  //ie
  if (explorer.indexOf("MSIE") >= 0) {
    return 'ie';
  }
  //firefox
 
  else if (explorer.indexOf("Firefox") >= 0) {
    return 'Firefox';
  }
  //Chrome
  else if (explorer.indexOf("Chrome") >= 0) {
    return 'Chrome';
  }
  //Opera
  else if (explorer.indexOf("Opera") >= 0) {
    return 'Opera';
  }
  //Safari
  else if (explorer.indexOf("Safari") >= 0) {
    return 'Safari';
  }
}
// 判断浏览器是否为IE
const exportToExcel = (data, name) => {
 
  // 判断是否为IE
  if (getExplorer() == 'ie') {
    tableToIE(data, name)
  } else {
    tableToNotIE(data, name)
  }
}
 
const Cleanup = () => {
  window.clearInterval(idTmr);
}
 
// ie浏览器下执行
const tableToIE = (data, name) => {
  let curTbl = data;
  let oXL = new ActiveXObject("Excel.Application");
 
  //创建AX对象excel
  let oWB = oXL.Workbooks.Add();
  //获取workbook对象
  let xlsheet = oWB.Worksheets(1);
  //激活当前sheet
  let sel = document.body.createTextRange();
  sel.moveToElementText(curTbl);
  //把表格中的内容移到TextRange中
  sel.select;
  //全选TextRange中内容
  sel.execCommand("Copy");
  //复制TextRange中内容
  xlsheet.Paste();
  //粘贴到活动的EXCEL中
 
  oXL.Visible = true;
  //设置excel可见属性
 
  try {
    let fname = oXL.Application.GetSaveAsFilename("Excel.xls", "Excel Spreadsheets (*.xls), *.xls");
  } catch (e) {
    print("Nested catch caught " + e);
  } finally {
    oWB.SaveAs(fname);
 
    oWB.Close(savechanges = false);
    //xls.visible = false;
    oXL.Quit();
    oXL = null;
    // 结束excel进程，退出完成
    window.setInterval("Cleanup();", 1);
    idTmr = window.setInterval("Cleanup();", 1);
  }
}
 
// 非ie浏览器下执行
const tableToNotIE = (function () {
  // 编码要用utf-8不然默认gbk会出现中文乱码
  const uri = 'data:application/vnd.ms-excel;base64,',
    template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
        
  const base64 = function (s) {
    return window.btoa(unescape(encodeURIComponent(s)));
  }
 
  const format = (s, c) => {
    return s.replace(/{(\w+)}/g,
      (m, p) => {
        return c[p];
      })
  }
 
  return (table, name) => {
    const ctx = {
      worksheet: name,
      table
    }
 
    const url = uri + base64(format(template, ctx));
 
    if (navigator.userAgent.indexOf("Firefox") > -1) {
      window.location.href = url
    } else {
      const aLink = document.createElement('a');
      aLink.href = url;
      aLink.download = name || '';
      let event;
      if (window.MouseEvent) {
        event = new MouseEvent('click');
      } else {
        event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      }
      aLink.dispatchEvent(event);
    }
  }
})()
 
// 导出函数
export function   ExcelTest (column, data, excelName){
  const typeMap = {
    image: getImageHtml,
    text: getTextHtml
  }
 
  let thead = column.reduce((result, item) => {
    result += `<th>${item.title}</th>`
    return result
  }, '')
 
  thead = `<thead><tr>${thead}</tr></thead>`
  var tbody = ``
  for (var item of data) {
    var temp = ``
    for (var item1 of column) {
      //temp +=   typeMap[item1.type || 'text'](item[item1.key], item1)
      if(item1.type=="image"){
        //temp += getImageHtml([item1.key], item1);
        temp += getImageHtml(item[[item1.key]], item1);
      }else{
        temp += getTextHtml(item[[item1.key]], item1);
      }
    }
    tbody += `<tr>${temp}</tr>`
  }
 
  tbody = `<tbody>${tbody}</tbody>`
 
  const table = thead + tbody
  // console.log(table)
  // 导出表格
  exportToExcel(table, excelName)
 
  function getTextHtml (val) {
   /* return new Promise((resolve, reject) => {
      resolve(`<td style="text-align: center;vnd.ms-excel.numberformat:@">${val}</td>`)
    })*/
     return `<td style="text-align: center;vnd.ms-excel.numberformat:@">${val}</td>`
  }
 
  function imgUrlToBase64 (url) {
   return new Promise((resolve, reject) => {
    debugger
      if (!url) {
       // resolve('')
      }
      if (/\.(png|jpe?g|gif|svg|jpg)(\?.*)?$/.test(url)) {
        // 图片地址
        const image = new Image()
        // 设置跨域问题
        image.setAttribute('crossOrigin', 'anonymous')
        // 图片地址
        image.src = url
        image.onload = () => {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          canvas.width = image.width
          canvas.height = image.height
          ctx.drawImage(image, 0, 0, image.width, image.height)
          // 获取图片后缀
          const ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase()
          // 转base64
          const dataUrl = canvas.toDataURL(`image/${ext}`)
          console.log(dataUrl)
          return dataUrl;
        }
      } else {
        // 非图片地址
       // resolve('非(png/jpe?g/gif/svg等)图片地址');
      }
   })
 
  }
  /*function getImageHtml (val, options) {
   var base64url= imgUrlToBase64(val);
   
   return '<td style="text-align: center; vertical-align: middle"><img  src="'+base64url+'"></td>'; 

    /*
      imgUrlToBase64(val).then(res => {
        options = Object.assign({ width: 40, height: 60 }, options)
        // resolve(`<td style="width: ${options.width}px; height: ${options.height}px; text-align: center; vertical-align: middle"><img  src="${res}" width=${options.width} height=${options.height}></td>`)
      return '<td style="width: ${options.width}px; height: ${options.height}px; text-align: center; vertical-align: middle"><img  src="${res}" width=${options.width} height=${options.height}></td>'; 
    }).catch(e => {
        //resolve(e)
      })
    
  }*/
  function getImageHtml(val, options) {
    options = Object.assign({width: 30, height: 30}, options)
    const valList = val;
    let tdStr = ''
    if(valList!=undefined&&valList.length>0){
    for (let i = 0; i < valList.length; i++) {
    //  var  base64url= imgUrlToBase64(valList[i]);
      tdStr += `<img src="${valList[i]}" width=${options.width} height=${options.height}>`
     // tdStr += `<img src="${base64url}" width=${options.width} height=${options.height}>`
    }
    console.log(tdStr)
    }
     var td= '<td style="width:200px; height:50px;text-align: center; vertical-align: middle"><div style="display:inline;">'+tdStr+'</div></td>'
    return td
  }

}
 
//export default table2excel